import $ from "cash-dom";

export default (function () {
    $(document).ready(function () {
        var selector = "[data-lightbox]";

        if ($(selector).length) {
            if (log) console.log("%cfunction_zoom-image.js initialized", "color: green;");
            var $button = $(selector);
            var $lightbox = $(
                `<div id="lightbox" class="fixed inset global px-global py-global transition-md fade-in bg-black scroll-x scroll-y center-content"></div>`
            );
            var $closeButton =
                $(`<button class="tab pointer aspect-1:1 c-white hover:c-accent width-1.0 fixed top-1.0 right-1.0 radius-round flex center-content stack" title="${jdmn_l10n.close}">
                    <svg class="icon stroke-lg" style="aspect-ratio: 1"><use href="#close"></use></svg>
                    <span class="sr-text">${jdmn_l10n.close}</span>
                </button>`);

            function closeHandler() {
                $lightbox.removeClass("on").on("transitionend", function () {
                    $lightbox.children().not($closeButton).remove();
                    $lightbox.remove();
                    $("html").removeClass("scroll-locked");
                });
            }

            $button.on("click", function () {
                var $instance = $(this).parents(".layout");
                var target = $(this).attr("data-lightbox") || "img";
                var $target = $instance.find(target);
                var $clone = $target.clone();
                var targetRatio = $target.width() / $target.height();
                var parentRatio = window.innerWidth / window.innerHeight;
                var data = {
                    sizes: $target.is("img") ? $target.attr("data-sizes") || Math.round($target.width()) + "px" : null,
                    srcset: $target.attr("data-srcset") || $target.attr("srcset"),
                    src: $target.attr("data-src") || $target.attr("src"),
                    type: $target.attr("data-type") || $target.attr("type"),
                };

                targetRatio = Math.ceil(targetRatio * 100) / 100;
                parentRatio = Math.ceil(parentRatio * 100) / 100;

                if (targetRatio > parentRatio) {
                    $clone.css({ width: "auto", height: "100%", "min-width": "unset", "min-height": "unset" });
                }

                if (targetRatio < parentRatio) {
                    $clone.css({ width: "100%", height: "auto", "min-width": "unset", "min-height": "unset" });
                }

                $clone
                    .attr({
                        src: data.src,
                        srcset: data.srcset,
                        sizes: data.sizes,
                        type: data.type,
                    })
                    .removeAttr("data-src data-srcset data-sizes data-type")
                    .removeClass("hide");

                $lightbox.append($clone);
                $lightbox.append($closeButton);
                $("body").append($lightbox);

                if ($clone.is("video") || $clone.is("audio")) {
                    $clone[0].load();
                }

                setTimeout(function () {
                    $lightbox.addClass("on");
                    $("html").addClass("scroll-locked");
                }, 0);
            });

            $closeButton.on("click", closeHandler);
            $(window).on("escKey", closeHandler);
        }
    });
})();
